<template>
  <gkFormText
    validity
    :group="group"
    :field="field"
    :trigger="trigger"
    type="text"
    :size="size"
    :color="color"
    :placeholder="placeholder"
    :length="length"
    :rule="mergeRule"
    :disabled="disabled"
    :customRule="customRule"
    v-model="currentValue"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  />
</template>

<script>
import VueTypes from 'vue-types'

import gkFormText from 'gkui/form/FormText'
import formProps from 'gkui/form/form.props'
import validityProps from 'gkui/form/validity.props'

export default {
  name: 'email',
  components: {
    gkFormText
  },
  props: Object.assign({}, formProps, validityProps, {
    field: VueTypes.string.def('email'),
    placeholder: VueTypes.string.def('邮箱'),
    length: VueTypes.number.def(64),
    rule: VueTypes.oneOfType([String, Array]).def(['required', 'email'])
  }),
  data () {
    return {
      currentValue: this.value
    }
  },
  computed: {
    mergeRule () {
      return this.rule.map(item => {
        if (item === 'required') {
          return {
            required: '请输入正确的邮箱'
          }
        }

        if (item === 'email') {
          return {
            email: '请输入正确的邮箱'
          }
        }

        return item
      })
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    }
  }
}
</script>
